import { createEntityAdapter } from '@reduxjs/toolkit';
import { stringPropertyComparator } from '@utils/common.utils';

import { Flight, Vertiport } from '@/types/intercom/intercom.types';

export const vertiportAdapter = createEntityAdapter<Vertiport, string>({
  selectId: (vertiport) => vertiport.code,
  sortComparer: stringPropertyComparator('code'),
});

export const flightAdapter = createEntityAdapter<Flight, string>({
  selectId: (flight) => flight.id,
  sortComparer: stringPropertyComparator('id'),
});
